import { Component, OnInit } from '@angular/core';
import { RazmjestiComponent } from './razmjesti.component';

@Component({
  selector: 'app-razmjesti-iz-vise',
  templateUrl: './razmjesti-iz-vise.component.html'
})
export class RazmjestiIzViseComponent
  extends RazmjestiComponent
  implements OnInit
{
  override ngOnInit() {
    this.razmjestiActionName =
      'potvrdiRazmjestanjeFizickihObjekataIzViseRazine';
    this.razmjestiListName = 'razmjesti_iz_vise_list';
    super.ngOnInit();
  }
}
